<template>
  <div class="wrap">
    <div class="centro">
      <header class="topo">
        <div class="container filter-container">
          <div class="row">
            <div class="col-6">
              <v-btn flat large icon color="primary" to="/provisao-aprovar">
                <v-icon dark>keyboard_backspace</v-icon>
              </v-btn>
            </div>
            <div class="col-6">
              <v-btn color="primary" flat @click.stop="limparFiltros"
                >Limpar filtros</v-btn
              >
            </div>
          </div>
        </div>
      </header>

      <section class="section-list">
        <form action="">
          <div class="container filter-container">
            <div class="row">
              <div class="col-md-12">
                <h2 class="titulo-filtro">
                  Filtrar por:
                </h2>
              </div>
              <div class="col-md-12">
                <v-select
                  item-text="nome"
                  item-value="identificador"
                  :items="localExecucao.data"
                  v-model="localExecucao.selected"
                ></v-select>
              </div>
            </div>

            <div class="row container-check container-check-padding-top">
              <div class="col-6 coluna-check">
                <label class="control control-radio name">
                  Últimos 05 Dias
                  <input
                    type="radio"
                    v-model="quantidadeDias"
                    value="5"
                    name="radio"
                  />
                  <div class="control_indicator"></div>
                </label>
              </div>

              <div class="col-6 coluna-check">
                <label class="control control-radio name">
                  Últimos 10 Dias
                  <input
                    type="radio"
                    v-model="quantidadeDias"
                    value="10"
                    name="radio"
                  />
                  <div class="control_indicator"></div>
                </label>
              </div>
            </div>

            <div class="row container-check">
              <div class="col-6 coluna-check">
                <label class="control control-radio name">
                  Últimos 15 Dias
                  <input
                    type="radio"
                    v-model="quantidadeDias"
                    id="ultimos15dias"
                    value="15"
                    name="radio"
                  />
                  <div class="control_indicator"></div>
                </label>
              </div>

              <div class="col-6 coluna-check">
                <label class="control control-radio name">
                  Últimos 30 Dias
                  <input
                    type="radio"
                    v-model="quantidadeDias"
                    value="30"
                    name="radio"
                  />
                  <div class="control_indicator"></div>
                </label>
              </div>
            </div>
          </div>
        </form>
      </section>
    </div>

    <section class="box-full box-cinza">
      <div class="centro-calendar">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <div id="content">
                <vc-date-picker
                  mode="range"
                  v-model="periodo"
                  show-caps
                  is-inline
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="centro">
      <section>
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <v-btn color="primary" block large @click.stop="filtrar"
                >Filtrar</v-btn
              >
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import Moment from 'moment'
import Timezone from 'moment-timezone'
import { NumberMixin, DateMixin } from '@finx/web-repository/src/mixin/_'
import ApiLegacy from '@finx/web-repository/src/apis/Legacy/Legacy'
import { APROVAR_MUT_DATA_INICIAL, APROVAR_MUT_DATA_FINAL, APROVAR_MUT_LOCALEXECUCAO, APROVAR_DIS_LISTAR } from '@/store/medico/provisao/aprovar-const'
import AprovarStore from '@/store/medico/provisao/aprovar'

export default {
  components: {},
  mixins: [NumberMixin, DateMixin],
  watch: {
    quantidadeDias(newValue) {
      if (newValue) {
        const days = _.parseInt(newValue) * -1

        Vue.set(
          this.periodo,
          'start',
          Moment()
            .add(days, 'days')
            .toDate(),
        )
        Vue.set(this.periodo, 'end', Moment().toDate())
      }
    },
  },
  data() {
    return {
      quantidadeDias: null,
      periodo: { start: null, end: null },
      localExecucao: {
        data: [],
        selected: null,
        state: null,
        errorMessage: 'Necessário preencher o local de execução',
      },
    }
  },
  methods: {
    limparFiltros() {
      this.quantidadeDias = null

      Vue.set(this.localExecucao, 'selected', null)
      Vue.set(
        this.periodo,
        'start',
        Moment()
          .add(-7, 'days')
          .toDate(),
      )
      Vue.set(this.periodo, 'end', Moment().toDate())
    },
    filtrar() {
      const dataInicial = this.periodo.start
      dataInicial.setHours(0)
      dataInicial.setMinutes(0)
      dataInicial.setSeconds(0)
      dataInicial.setMilliseconds(0)

      const dataFinal = this.periodo.end
      dataFinal.setHours(23)
      dataFinal.setMinutes(59)
      dataFinal.setSeconds(59)
      dataFinal.setMilliseconds(999)

      AprovarStore.commit(
        APROVAR_MUT_DATA_INICIAL,
        this.tranformDate2Epoch(dataInicial),
      )
      AprovarStore.commit(
        APROVAR_MUT_DATA_FINAL,
        this.tranformDate2Epoch(dataFinal),
      )

      if (this.localExecucao.selected != null) {
        AprovarStore.commit(APROVAR_MUT_LOCALEXECUCAO, this.localExecucao.selected.identificador)
      } else {
        AprovarStore.commit(APROVAR_MUT_LOCALEXECUCAO, null)
      }

      AprovarStore.dispatch(APROVAR_DIS_LISTAR)
      this.$router.push('/provisao-aprovar')
    },
  },
  created() {
    const that = this

    Vue.set(
      this.periodo,
      'start',
      Moment()
        .add(-7, 'days')
        .toDate(),
    )
    Vue.set(this.periodo, 'end', Moment().toDate())

    ApiLegacy.Provisao.listarLocalExecucao().then((result) => {
      if (result.success) {
        if (result.data === null || result.data.length === 0) {
          that.localExecucao.data = []
          that.localExecucao.state = false
          that.localExecucao.errorMessage = 'Nenhum local de execução negociado para o médico'
        } else that.localExecucao.data = result.data
      } else {
        that.localExecucao.state = false

        if (result.error) {
          that.localExecucao.errorMessage = result.error[0].userMessage
        }
      }
    })
  },
}
</script>

<style scoped>
/*container*/
.wrap {
  margin: 0 auto;
  width: 100%;
}
.centro {
  margin: 0 auto;
  width: 90%;
}
@media (min-width: 760px) {
  .wrap {
    width: 350px;
  }
}
/*Header*/
.topo {
  position: relative;
}
.topo .container {
  padding: 15px 0 26px 0;
}
.limp-text {
  font-size: 16px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 2;
  letter-spacing: normal;
  color: #03a5ed;
  position: absolute;
  right: 0;
  top: -1px;
}
/*sections*/
.section-list .container {
  padding: 26px 0;
}
.titulo-filtro {
  font-size: 26px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.23;
  letter-spacing: normal;
  color: #091337;
}
.item {
  border: none;
  border-bottom: 1px solid #e3e6e3;
  margin-bottom: 31px;
  padding: 15px 0;
  width: 100%;
}
.item::placeholder {
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 0.89;
  letter-spacing: normal;
  color: #a4a5a4;
}
label {
  display: inline-block;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1;
  letter-spacing: normal;
  color: #a4a5a4;
}
.espaco-row {
  margin-top: 31px;
}
/*Calendario*/
.box-full {
  background-color: #f5f7f5;
}
/*Checkbox coluna*/
.container-check {
  display: flex;
  flex-direction: row;
  padding: 15px 0;
}
.container-check-padding-top {
  margin-top: 15px;
}
.coluna-check {
  width: 167px;
}
.coluna-check-esquerda {
  margin-left: 4px;
}
/*Calendário*/
.box-cinza {
  background-color: transparent;
}
.box-full {
  display: flex;
  flex-direction: column;
}
.c-pane {
  width: 100%;
}
.c-pane-container {
  background-color: transparent !important;
  border: none !important;
  display: block;
  margin: 0 auto;
  width: 90%;
}
.c-arrow-layout svg {
  color: #62cbcf !important;
}
.c-day-content {
  background-color: #337789;
}
.c-header .c-title-layout .c-title-popover .c-title-anchor .c-title {
  color: #091337 !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  font-style: normal !important;
  font-stretch: normal !important;
  line-height: normal !important;
  letter-spacing: normal !important;
  text-align: center !important;
}

@media (max-width: 768px) {
  .filter-container {
    padding: 26px 15px !important;
  }
}

.logar {
  width: 100%;
}
.form-group {
  position: relative;
  width: 100%;
}
.form-group label {
  position: absolute;
  transition: 0.2s ease-out;
}
input[type="password"]::placeholder {
  font-size: 18px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 0.89;
  letter-spacing: normal;
}
.senha-campo:focus {
  background-color: #fff;
  border-bottom: 1px solid #03a5ed;
  box-shadow: none;
  outline: none;
  background-position: 0 0;
  font-size: 18px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 0.89;
  letter-spacing: normal;
}
fieldset {
  margin: 0;
  padding: 0;
  border: 0;
}
input[type="password"] {
  border: none;
  border-bottom: 1px solid #e3e6e3;
  display: block;
  width: 100%;
  padding: 16px 8px;
  background: rgba(255, 255, 255, 0.97);
  font-size: 18px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 1;
  letter-spacing: normal;
  outline: 0;
  transition: all 0.2s ease-in-out;
  width: 84%;
}

.form-label fieldset {
  position: relative;
}
.form-label fieldset:first-child input {
  border-radius: 4px 4px 0 0;
}
.form-label fieldset:last-child input {
  border-radius: 0 0 4px 4px;
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.15);
}
.form-label fieldset + fieldset {
  border-top: 1px solid #ddd;
}
.form-label label {
  position: absolute;
  top: 15px;
  left: 8px;
  color: #909090;
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
  transition: all 0.2s ease-in-out;
}

.form-css-label input[data-empty="false"],
.form-css-label input:valid,
.form-css-label input:focus {
  padding: 22px 8px 10px;
}
.form-css-label input:focus {
  outline: 0;
  background: white;
}
.form-css-label input[data-empty="false"] + label,
.form-css-label input:valid + label,
.form-css-label input:focus + label {
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.14;
  letter-spacing: normal;
  color: #a4a5a4;
  -webkit-transform: translate3d(0, -10px, 0);
  transform: translate3d(0, -10px, 0);
}

.form-js-label input[data-empty="false"],
.form-js-label input:focus {
  padding: 30px 8px 10px;
}
.form-js-label input:focus {
  outline: 0;
  background: white;
}
.form-js-label input[data-empty="false"] + label,
.form-js-label input:focus + label {
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.14;
  letter-spacing: normal;
  color: #a4a5a4;
  -webkit-transform: translate3d(0, -17px, 0);
  transform: translate3d(0, -17px, 0);
}
/*Checkbox*/
.logar {
  width: 100%;
}
.form-group {
  position: relative;
}
.form-group label {
  position: absolute;
  transition: 0.2s ease-out;
}

/*Checkbox*/
.control {
  display: block;
  position: relative;
  padding-left: 26px;
  margin-bottom: 5px;
  padding-top: 3px;
  cursor: pointer;
}
.control input {
  position: absolute;
  z-index: -1;
  opacity: 0;
}
.control_indicator {
  position: absolute;
  top: 2px;
  left: 0;
  height: 20px;
  width: 20px;
  background: #ffffff;
  border: 2px solid #03a5ed;
}
.control_indicator:hover {
  border: 2px solid #3ee9ff;
}
.control-radio .control_indicator {
  border-radius: 50%;
}
.control:hover input ~ .control_indicator,
.control input:focus ~ .control_indicator {
  background: #ffffff;
}

.control input:checked ~ .control_indicator {
  background: #ffffff;
}
.control:hover input:not([disabled]):checked ~ .control_indicator,
.control input:checked:focus ~ .control_indicator {
  background: #ffffff;
}
.control input:disabled ~ .control_indicator {
  background: #e6e6e6;
  opacity: 0.6;
  pointer-events: none;
}
.control_indicator:after {
  box-sizing: unset;
  content: "";
  position: absolute;
  display: none;
}
.control input:checked ~ .control_indicator:after {
  display: block;
}
.control-radio .control_indicator:after {
  left: 3px;
  top: 3px;
  height: 10px;
  width: 10px;
  border-radius: 50%;
  background: #03a5ed;
}
.control_indicator:hover::after {
  left: 18.26%;
  top: 2px;
  height: 10px;
  width: 10px;
  border-radius: 50%;
  background: #2652a3;
}
.control-radio input:disabled ~ .control_indicator:after {
  background: #2652a3;
}

.frase {
  color: #a4a5a4;
  line-height: 1.29;
  width: 233px;
}

.name {
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.14;
  letter-spacing: normal;
  color: #212121;
}

.centro-calendar .container {
  padding: 0;
}

.centro-calendar {
  margin-bottom: 25px;
}
</style>
